<template>
  <section class="naming-websites">
    <h2 class="text-h6">Website Logic</h2>
    <v-row>
      <v-col col="12"> </v-col>
    </v-row>

    <!-- <div v-for="item in doc.list" :key="item.id">

      <pre>{{ getRelatedWebsites(item.children, "DGDA") }}</pre>
    </div> -->
    <NamingWebsiteNested
      v-if="doc"
      :doc="doc"
      :arr="doc.local.websites.filter((x) => x !== 'Standalone')"
    />

    <v-row>
      <template v-for="stand in doc.list">
        <v-col
          v-for="sub in getRelatedWebsites(stand.children, 'Standalone')"
          :key="`standalone-${stand.name}-${sub.name}`"
          :cols="3"
          class="text-center website-box"
        >
          <div class="browser">{{ sub.name }}</div>
          <NamingWebsiteDeep :arr="sub.children" :doc="doc" tag="Standalone" />
        </v-col>
      </template>
    </v-row>

    <!-- <pre>{{ doc.list }}</pre> -->
  </section>
</template>

<script>
import NamingWebsiteNested from "./NamingWebsiteNested";
import NamingWebsiteDeep from "./NamingWebsiteDeep";
export default {
  name: "NamingLogos",
  data() {
    return {};
  },
  components: {
    NamingWebsiteNested,
    NamingWebsiteDeep,
  },
  props: {
    cols: {
      type: Number,
      default: 4,
    },
    id: {
      type: String,
      default: "diushoaidcs",
    },
    doc: {
      type: Object,
      default: () => ({}),
    },
  },
  watch: {},
  computed: {},

  methods: {
    getRelatedWebsites(arr, key) {
      // console.log(arr, key);
      const temp = [];
      arr.forEach((element) => {
        const testArray = element.websites;
        if (testArray.includes(key)) {
          temp.push(element);
        }
      });
      return temp;
    },
  },
};
</script>

<style lang="scss">
.website-box {
  text-align: left;
  .browser {
    width: 300px;
    height: 200px;
    border-top: 12px solid gray;
    border-bottom: 1px solid gray;
    border-left: 1px solid gray;
    border-right: 1px solid gray;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  ul {
    padding-left: 0;
    margin-left: 0;
    li {
      margin-left: 1.4rem;
      text-align: left;
    }
  }
}
</style>
